/* ============================================================
   Ceo Galileo — Motion Layer controller (cg-motion)
   - Otomatik: #MainContent içindeki her bölüm scroll'a girince belirir
   - Deklaratif: [data-cg-reveal], [data-cg-stagger], [data-cg-parallax]
   - prefers-reduced-motion'a saygı duyar
   - No-JS güvenli: stiller yalnız <html class="cg-motion"> iken aktiftir
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Stilleri aktive et (no-JS / JS-fail durumunda içerik gizlenmez)
  root.classList.add('cg-motion');

  function init() {
    setupStickyHeader(); // motion değil, kullanılabilirlik — reduced-motion'da da çalışır
    setupImageFeather(); // statik kenar yumuşatma — her zaman çalışır
    setupPlanetInfoTap(); // gezegen bilgi paneli: tıkla/dokun aç-kapa (mobil + masaüstü)
    setupCountdownReveal(); // countdown: mobilde başlığa tıkla → açıklama açılır
    setupFooterDropdowns(); // footer Learn/Policies: masaüstünde dropdown
    setupSolarCarousel();   // hero güneş sistemi: perspektif zincir + tıkla-öne-getir

    if (reduceMotion) {
      finalizeCounters(); // sayıları son değerine sabitle, animasyon yok
      return;
    }

    tagProductGrids(); // ürün ızgaralarını stagger grubu yap
    tagHeroGroups();   // hero başlık/buton giriş stagger'ı
    setupReveals();
    setupStaggerIndexes();
    setupParallax();
    setupCounters();
    setupMobileCardActive(); // dokunmatik: ekran ortasındaki kart "aktif"
    setupGlobalSky();        // site geneli sabit yıldız arka planı
    setupHeroStars();        // hero: twinkle yıldızlar + kayan yıldız
  }

  /* ---------- Footer Learn/Policies: masaüstünde tıkla → liste aç-kapa ----------
     Mobilde tema kendi akordeonunu kullanır; bu sadece masaüstünde devreye girer.
     Social ikon bloğu hariç tutulur. */
  function setupFooterDropdowns() {
    if (window.innerWidth <= 768) return;
    var titles = document.querySelectorAll('.site-footer--head .site-footer__section-title');
    titles.forEach(function (title) {
      if (title.dataset.cgFoot) return;
      var col = title.closest('[class*="col"]') || title.parentElement;
      if (!col || col.querySelector('.social-icons')) return; // social → atla
      var list = col.querySelector('ul');
      if (!list) return;
      title.dataset.cgFoot = '1';
      list.classList.add('cg-foot-list');
      col.classList.add('cg-foot-acc');
      title.addEventListener('click', function () { col.classList.toggle('cg-foot-open'); });
    });
  }

  /* ---------- Hero güneş sistemi: perspektif zincir carousel ----------
     Gezegenler diyagonal zincirde; ön(0) büyük sağda, geriye küçülerek sıralı.
     Arkadaki bir gezegene tıkla → smooth öne gelir, zincir kayar, boyutlar değişir. */
  function setupSolarCarousel() {
    document.querySelectorAll('.cg-hero__system').forEach(function (sys) {
      if (sys.__cgCarousel) return; sys.__cgCarousel = true;
      // Uydu zincire DAHİL DEĞİL (sol-altta dekoratif, CSS ile konumlanır)
      var planets = Array.prototype.slice.call(sys.querySelectorAll('.cg-hero__sysp')).filter(function (p) {
        return !p.classList.contains('cg-sysp--sat');
      });
      var n = planets.length;
      if (n < 2) return;
      var mode = sys.getAttribute('data-layout') || 'rainbow';
      function isM() { return window.innerWidth <= 768; }
      function sunMul() { return isM() ? 1.1 : 1.55; }   // güneş framing telafisi

      /* ===== ESKİ DİZİLİŞ (zincir / diyagonal) — CSS transition ===== */
      if (mode === 'chain') {
        var chainD = [
          { cx: 77, cy: 52, w: 26 }, { cx: 63, cy: 38, w: 18 }, { cx: 51, cy: 30, w: 13 },
          { cx: 41, cy: 26, w: 10 }, { cx: 33, cy: 24, w: 7.8 }, { cx: 27, cy: 23.5, w: 6.3 },
          { cx: 22, cy: 24.5, w: 5.4 }, { cx: 18, cy: 27, w: 4.7 }, { cx: 15, cy: 32, w: 4.2 }
        ];
        var chainM = [
          { cx: 67, cy: 35, w: 32 }, { cx: 47, cy: 25, w: 22 }, { cx: 33, cy: 19, w: 15 },
          { cx: 24, cy: 16, w: 11 }, { cx: 18, cy: 14.5, w: 8.5 }, { cx: 14, cy: 14.5, w: 6.8 },
          { cx: 11, cy: 16, w: 5.7 }, { cx: 9, cy: 19, w: 5 }, { cx: 8, cy: 23, w: 4.4 }
        ];
        var frontIdx = 0;
        var slotOf = function (i) { return ((i - frontIdx) % n + n) % n; };
        var layout = function () {
          var S = isM() ? chainM : chainD, m = S.length;
          planets.forEach(function (p, i) {
            var sl = slotOf(i), s = S[sl < m ? sl : m - 1];
            var wMul = p.classList.contains('cg-sysp--sun') ? sunMul() : 1;
            p.style.left = s.cx + '%'; p.style.top = s.cy + '%'; p.style.width = (s.w * wMul) + '%';
            p.style.zIndex = String(50 - sl);
            p.style.filter = sl === 0 ? 'none' : 'brightness(' + (1 - Math.min(sl, 6) * 0.06) + ')';
          });
        };
        planets.forEach(function (p, i) {
          p.addEventListener('click', function () { if (slotOf(i) !== 0) { frontIdx = i; layout(); } });
        });
        planets.forEach(function (p) { p.style.transition = 'none'; });
        layout(); void sys.offsetWidth;
        planets.forEach(function (p) { p.style.transition = ''; });
        var rtc; window.addEventListener('resize', function () { clearTimeout(rtc); rtc = setTimeout(layout, 160); }, { passive: true });
        return;
      }

      /* ===== ORBIT — Güneş merkezde, gezegenler eliptik halkada (referans diski) =====
         Güneş ortada sabit; 8 gezegen sabit boyutta elips üzerinde yavaş döner.
         ön(alt)=parlak+üstte (güneşin önünden geçer), arka(üst)=sönük+güneşin arkasında.
         Astronot dokunulmaz (system katmanı z1, astronot z3 → hep önde). */
      if (mode === 'orbit') {
        var preset = sys.getAttribute('data-orbit') || 'a';
        var sunEl = null, orb = [];
        planets.forEach(function (p) { if (p.classList.contains('cg-sysp--sun')) sunEl = p; else orb.push(p); });
        var m = orb.length;
        // cy/rx/ry = % ; tilt = derece (disk eğimi). Konumlar PİKSEL uzayında hesaplanır
        // → eğim en-boy oranından bozulmaz, referanstaki yatık disk birebir tutturulur.
        var PRESETS = {
          a: { cyD: 48, cyM: 44, rxD: 42, ryD: 27, rxM: 42, ryM: 11, sun: 20, tilt: -16 },
          b: { cyD: 46, cyM: 42, rxD: 47, ryD: 24, rxM: 45, ryM: 10, sun: 22, tilt: -12 },
          c: { cyD: 50, cyM: 46, rxD: 38, ryD: 30, rxM: 38, ryM: 12, sun: 26, tilt: -22 }
        };
        // SZ = görünür GÖVDE boyutu (% viewport-width). BİLİMSEL SIRA korunur, gerçek çaplardan
        // türetilip (çap^0.4) sıkıştırıldı → Güneş ≫ Jüpiter > Satürn > Uranüs≈Neptün > Dünya≈Venüs > Mars > Merkür.
        // Element genişliği = gövde / fill (motor halkalı gezegende kamerayı geri çekiyor → gövde kutunun ~%35'i; diğerleri ~%84).
        var SZ = { mercury: 3.0, venus: 4.3, earth: 4.4, mars: 3.4, jupiter: 11.4, saturn: 10.7, uranus: 7.7, neptune: 7.5 };
        var OSCALE = 0.9; // tüm orbit %10 küçültüldü (gezegenler ekran dışına taşmasın)
        function fillOf(p) { return p.classList.contains('cg-sysp--saturn') ? 0.35 : 0.84; }
        function curP() { return PRESETS[preset] || PRESETS.a; }
        function sizeOf(p) { for (var k in SZ) { if (p.classList.contains('cg-sysp--' + k)) return SZ[k] * OSCALE; } return 13 * OSCALE; }
        function geom() {
          var p = curP(), mob = isM();
          var W = sys.clientWidth || window.innerWidth, H = sys.clientHeight || window.innerHeight;
          var cx = 0.5 * W, cy = (mob ? p.cyM : p.cyD) / 100 * H;
          var rx = (mob ? p.rxM : p.rxD) / 100 * W * OSCALE, ry = (mob ? p.ryM : p.ryD) / 100 * H * OSCALE;
          var th = p.tilt * Math.PI / 180;
          return { W: W, H: H, cx: cx, cy: cy, rx: rx, ry: ry, sin: Math.sin(th), cos: Math.cos(th), tiltDeg: p.tilt, sun: p.sun * OSCALE };
        }
        var SVGNS = 'http://www.w3.org/2000/svg';
        var rings = document.createElementNS(SVGNS, 'svg');
        rings.setAttribute('class', 'cg-hero__orbit-rings');
        rings.setAttribute('preserveAspectRatio', 'none');
        rings.setAttribute('aria-hidden', 'true');
        sys.insertBefore(rings, sys.firstChild);
        function drawRings() {
          var g = geom();
          rings.setAttribute('viewBox', '0 0 ' + g.W + ' ' + g.H);
          while (rings.firstChild) rings.removeChild(rings.firstChild);
          var rotStr = 'rotate(' + g.tiltDeg + ' ' + g.cx.toFixed(1) + ' ' + g.cy.toFixed(1) + ')';
          for (var k = 1; k <= 4; k++) {
            var f = 0.42 + 0.58 * (k / 4);
            var el = document.createElementNS(SVGNS, 'ellipse');
            el.setAttribute('cx', g.cx.toFixed(1)); el.setAttribute('cy', g.cy.toFixed(1));
            el.setAttribute('rx', (g.rx * f).toFixed(1)); el.setAttribute('ry', (g.ry * f).toFixed(1));
            el.setAttribute('transform', rotStr);
            el.setAttribute('fill', 'none');
            el.setAttribute('stroke', 'rgba(255,255,255,' + (0.05 + 0.05 * (k / 4)).toFixed(3) + ')');
            el.setAttribute('stroke-width', '1');
            el.setAttribute('vector-effect', 'non-scaling-stroke');
            rings.appendChild(el);
          }
        }
        var rotA = 0, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        function place() {
          var g = geom(), mob = isM();
          if (sunEl) {
            sunEl.style.transition = 'none';
            // Konum TRANSFORM ile (left/top DEĞİL): layout kutusu sabit kalır → clientW/H oynamaz →
            // motor resize() tetiklenmez → canvas her kare yeniden ölçeklenip TİTREMEZ. (Net dokuda görünür hale gelen kök sebep.)
            sunEl.style.left = '0'; sunEl.style.top = '0';
            sunEl.style.transform = 'translate(' + g.cx.toFixed(2) + 'px,' + g.cy.toFixed(2) + 'px) translate(-50%,-50%)';
            sunEl.style.width = g.sun + '%'; sunEl.style.zIndex = '30'; sunEl.style.filter = 'none';
          }
          for (var i = 0; i < m; i++) {
            var phi = rotA + (i / m) * 2 * Math.PI;
            var ex = g.rx * Math.sin(phi), ey = g.ry * Math.cos(phi);
            var dx = ex * g.cos - ey * g.sin, dy = ex * g.sin + ey * g.cos;   // disk eğimiyle döndür
            var depth = (Math.cos(phi) + 1) / 2;
            orb[i].style.transition = 'none';
            orb[i].style.left = '0'; orb[i].style.top = '0';
            orb[i].style.transform = 'translate(' + (g.cx + dx).toFixed(2) + 'px,' + (g.cy + dy).toFixed(2) + 'px) translate(-50%,-50%)';
            orb[i].style.width = (sizeOf(orb[i]) / fillOf(orb[i]) * (mob ? 0.85 : 1)) + '%';
            orb[i].style.zIndex = String(Math.round(depth * 60));
            orb[i].style.filter = 'brightness(' + (0.85 + 0.15 * depth) + ')';  // hafif derinlik pusu (güneş-ışığını ezmesin)
            // ışık merkezden (güneşten) gelsin: aydınlık taraf güneşe baksın (eğimli vektör)
            var key = orb[i].__cgKey, ld = orb[i].__cgLightDist;
            if (key && ld) {
              var lc = orb[i].__cgLC, ox = lc ? lc.x : 0, oy = lc ? lc.y : 0, oz = lc ? lc.z : 0;
              var vx = -dx, vy = -dy, L = Math.sqrt(vx * vx + vy * vy) || 1; vx /= L; vy /= L;
              // DERİNLİK FARKINDALI: ışığın z'si gezegenin yörüngedeki ön/arka konumuna göre (cos(phi)).
              // Arka (güneşin arkasında) gezegenler kameraya dönük aydınlık; ön gezegenler arkadan aydınlık (hilal).
              // → "güneş ortada, kamera güneşle aynı hatta" geometrisi DOĞRU yansır.
              key.position.set(ox + vx * ld, oy - vy * ld, oz - Math.cos(phi) * ld * 0.75);
            }
          }
        }
        var last = 0;
        function loop(ts) { if (!last) last = ts; var dt = Math.min((ts - last) / 1000, 0.1); last = ts; rotA += dt * 0.05; place(); requestAnimationFrame(loop); }
        drawRings(); place();
        if (!reduce) requestAnimationFrame(loop);
        var rrt; window.addEventListener('resize', function () { clearTimeout(rrt); rrt = setTimeout(function () { drawRings(); place(); }, 150); }, { passive: true });
        return;
      }

      /* ===== YUVARLAK / ORBIT — elips üzerinde dönüş (rAF, daire akışı) =====
         Gezegenler bir elips (perspektif daire) üzerinde; ön(phi=0)=alt-merkez büyük (astronot arkası),
         arkaya doğru küçülür. Tıkla → o gezegen daire üzerinde dönerek öne gelir. */
      planets.forEach(function (p) { p.style.transition = 'filter .35s ease'; }); // konum rAF ile
      function ell() {
        // base = öndeki(seçili) boyut; minS = en UZAKTAKİ (karşı) gezegenin oranı.
        // Seçiliden uzaklaştıkça boyut kademeli küçülür.
        return isM()
          ? { cx: 50, cy: 33, rx: 33, ry: 17, base: 30, minS: 0.32 }
          : { cx: 50, cy: 38, rx: 39, ry: 18.5, base: 20, minS: 0.32 };
      }
      // --- Elips yay-uzunluğu tablosu: gezegenleri açıyla değil YAY ile dağıt →
      //     daire üzerinde aralar EŞİT görünür (yanlarda kümelenme olmaz). ---
      var _arc = null, _arcKey = '';
      function buildArc(e) {
        var key = e.rx + 'x' + e.ry;
        if (key === _arcKey && _arc) return _arc;
        var STEPS = 720, phis = [0], cum = [0], len = 0, px = 0, py = e.ry;
        for (var k = 1; k <= STEPS; k++) {
          var ph = k / STEPS * 2 * Math.PI, x = e.rx * Math.sin(ph), y = e.ry * Math.cos(ph);
          len += Math.sqrt((x - px) * (x - px) + (y - py) * (y - py));
          phis.push(ph); cum.push(len); px = x; py = y;
        }
        _arc = { phis: phis, cum: cum, total: len }; _arcKey = key; return _arc;
      }
      function phiOf(s, e) {                       // s∈[0,1) (yay-oranı) → phi
        var a = buildArc(e), t = (s - Math.floor(s)) * a.total, lo = 0, hi = a.cum.length - 1;
        while (lo < hi) { var m = (lo + hi) >> 1; if (a.cum[m] < t) lo = m + 1; else hi = m; }
        var i0 = lo > 0 ? lo - 1 : 0, seg = a.cum[lo] - a.cum[i0];
        var f = seg > 0 ? (t - a.cum[i0]) / seg : 0;
        return a.phis[i0] + (a.phis[lo] - a.phis[i0]) * f;
      }
      // s=0 → phi=0 → alt-merkez (astronotun arkası, ÖN).
      var sBase = planets.map(function (_, i) { return i / n; });
      var rotS = 0, targetS = 0, animating = false;
      var SAT_BOOST = 0.20;                            // Satürn görsel olarak %20 büyük
      var SAT_SPACE = 0.133;                           // çevresine eklenen yay payı (kenar boşluğu eşit kalsın)
      var satIdx = -1;
      planets.forEach(function (p, i) { if (p.classList.contains('cg-sysp--saturn')) satIdx = i; });
      function falloff(d, m) {                        // d=öne uzaklık 0..0.5 → boyut oranı
        var f = 1 - d / 0.5;                          // 1(seçili)..0(en uzak)
        return m + (1 - m) * f * f;                   // KARESEL: yanlardakiler hızlı küçülür
      }
      function sizeFracAt(t, m) {                      // t∈[0,1) → öne göre boyut oranı
        return falloff(t < 0.5 ? t : 1 - t, m);
      }
      // Boyut-ağırlıklı dağılım: büyük (öndeki) gezegenler daha geniş aralıklı,
      // küçük (arkadaki) sıkışık. AYRICA Satürn %15 büyük olduğundan onun çevresine
      // yerel pay eklenir → tüm KENAR boşlukları yine eşit görünür (Satürn dönerken taşınır).
      function buildRemap(m, satSf) {
        var M = 240, cum = [0], tot = 0, k, w = 1 / n;
        for (k = 0; k < M; k++) {
          var t = (k + 0.5) / M, de = sizeFracAt(t, m);
          if (satIdx >= 0 && satSf >= 0) {
            var dd = Math.abs(t - satSf); if (dd > 0.5) dd = 1 - dd;   // dairesel uzaklık
            if (dd < w) de *= (1 + SAT_SPACE * (1 - dd / w));          // satürn çevresi payı
          }
          tot += de; cum.push(tot);
        }
        for (k = 0; k <= M; k++) cum[k] /= tot;
        return { M: M, cum: cum };
      }
      function render() {
        var e = ell();
        var satSf = satIdx >= 0 ? (((sBase[satIdx] + rotS) % 1) + 1) % 1 : -1;
        var rm = buildRemap(e.minS, satSf);
        planets.forEach(function (p, i) {
          var slot = sBase[i] + rotS;
          var sf = slot - Math.floor(slot);           // 0..1 (0=ön/seçili)
          var pp = sf * rm.M, idx = Math.floor(pp), ff = pp - idx; if (idx >= rm.M) idx = rm.M - 1;
          var arc = rm.cum[idx] + (rm.cum[idx + 1] - rm.cum[idx]) * ff;
          var phi = phiOf(arc, e);                     // boyut-ağırlıklı yay konumu
          var depth = (Math.cos(phi) + 1) / 2;        // ön=1, arka=0 → parlaklık/z
          var d = sf > 0.5 ? 1 - sf : sf;             // öne uzaklık 0..0.5
          var w = e.base * falloff(d, e.minS);        // uzaklaştıkça (karesel) küçülür
          if (i === satIdx) w *= (1 + SAT_BOOST);     // Satürn %15 büyük (yalnız görsel)
          p.style.left = (e.cx + e.rx * Math.sin(phi)) + '%';
          p.style.top = (e.cy + e.ry * Math.cos(phi)) + '%';
          p.style.width = w + '%';
          p.style.zIndex = String(Math.round(depth * 100) + 1);
          p.style.filter = 'brightness(' + (0.42 + 0.58 * depth) + ')';
        });
      }
      function animate() {
        var d = targetS - rotS;
        if (Math.abs(d) < 0.0008) { rotS = targetS; render(); animating = false; return; }
        rotS += d * 0.12; render(); requestAnimationFrame(animate);
      }
      planets.forEach(function (p, i) {
        p.addEventListener('click', function () {
          var want = -sBase[i];                       // bu gezegen öne (s=0) gelsin
          while (want - rotS > 0.5) want -= 1;        // en kısa yön
          while (want - rotS < -0.5) want += 1;
          targetS = want;
          if (!animating) { animating = true; requestAnimationFrame(animate); }
        });
      });
      render();
      var rto; window.addEventListener('resize', function () { clearTimeout(rto); rto = setTimeout(render, 120); }, { passive: true });
    });
  }

  /* ---------- Countdown: mobilde başlığa tıkla → açıklama aç-kapa ----------
     Masaüstünde açıklama hep görünür (CSS sadece <=768'de gizler); burada
     tıklama her zaman bağlanır, masaüstünde görsel etkisi olmaz. */
  function setupCountdownReveal() {
    var titles = document.querySelectorAll('.cg-cd-title');
    if (!titles.length) return;
    titles.forEach(function (t) {
      if (t.dataset.cgCd) return;
      t.dataset.cgCd = '1';
      var box = t.parentElement; // title + des'i içeren kolon
      if (!box || !box.querySelector('.cg-cd-des')) return;
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      t.addEventListener('click', function () { box.classList.toggle('cg-cd-open'); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); box.classList.toggle('cg-cd-open'); }
      });
    });
  }

  /* ---------- Gezegen bilgi paneli: tıkla/dokun aç-kapa ----------
     Hover masaüstünde çalışır; dokunmatikte hover yok → tıklayınca açılır.
     Başka yere/gezegene tıklayınca kapanır. */
  function setupPlanetInfoTap() {
    var stages = document.querySelectorAll('.cg-planet-stage');
    if (!stages.length) return;
    stages.forEach(function (stage) {
      if (!stage.querySelector('.cg-planet-info')) return;
      // dokunmatik: swipe/scroll'u tap'tan ayır → kaydırırken panel açılmasın
      var sx = 0, sy = 0, swiped = false;
      stage.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; sx = t.clientX; sy = t.clientY; swiped = false;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        if (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10) swiped = true;
      }, { passive: true });
      stage.addEventListener('click', function () {
        if (swiped) { swiped = false; return; } // kaydırma hareketi → yoksay
        var willOpen = !stage.classList.contains('cg-info-open');
        document.querySelectorAll('.cg-planet-stage.cg-info-open').forEach(function (s) {
          s.classList.remove('cg-info-open');
        });
        if (willOpen) stage.classList.add('cg-info-open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.cg-planet-stage')) {
        document.querySelectorAll('.cg-planet-stage.cg-info-open').forEach(function (s) {
          s.classList.remove('cg-info-open');
        });
      }
    });
  }

  /* ---------- Site geneli sabit yıldız gökyüzü ----------
     Tüm sayfanın arkasında (fixed) derin uzay arka planı. body/#MainContent
     şeffaflaştırılır (CSS), karanlık alanlarda yıldızlar görünür. */
  function setupGlobalSky() {
    if (document.querySelector('.cg-sky')) return;
    var sky = document.createElement('div');
    sky.className = 'cg-sky';
    sky.setAttribute('aria-hidden', 'true');
    var n = 120;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var s = document.createElement('span');
      s.className = 'cg-star';
      var size = Math.random() < 0.7 ? 1 : 2;
      s.style.left = (Math.random() * 100).toFixed(2) + '%';
      s.style.top = (Math.random() * 100).toFixed(2) + '%';
      s.style.width = size + 'px';
      s.style.height = size + 'px';
      s.style.setProperty('--cg-tw-dur', (2.6 + Math.random() * 4.5).toFixed(2) + 's');
      s.style.animationDelay = '-' + (Math.random() * 6).toFixed(2) + 's';
      frag.appendChild(s);
    }
    sky.appendChild(frag);
    document.body.insertBefore(sky, document.body.firstChild);
    scheduleShootingStar(sky);
  }

  /* ---------- Hero gökyüzü: twinkle yıldızlar + kayan yıldız ----------
     Statik PNG yıldız alanının üstüne birkaç parlak yanıp sönen yıldız ve
     arada bir diyagonal kayan yıldız ekler. */
  function setupHeroStars() {
    document.querySelectorAll('.cg-hero__stars').forEach(function (layer) {
      if (layer.dataset.cgStarsReady) return;
      layer.dataset.cgStarsReady = '1';

      var n = 24; // PNG zaten bir alan veriyor; bunlar parlak vurgular
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        s.className = 'cg-star';
        var size = Math.random() < 0.75 ? 2 : 3;
        s.style.left = (Math.random() * 100).toFixed(2) + '%';
        s.style.top = (Math.random() * 74).toFixed(2) + '%';
        s.style.width = size + 'px';
        s.style.height = size + 'px';
        s.style.setProperty('--cg-tw-dur', (2.4 + Math.random() * 4).toFixed(2) + 's');
        s.style.animationDelay = '-' + (Math.random() * 6).toFixed(2) + 's';
        frag.appendChild(s);
      }
      layer.appendChild(frag);
      scheduleShootingStar(layer);
    });
  }

  function scheduleShootingStar(layer) {
    var delay = 7000 + Math.random() * 13000; // 7–20 sn arası
    setTimeout(function () {
      if (!document.hidden) spawnShootingStar(layer);
      scheduleShootingStar(layer);
    }, delay);
  }

  function spawnShootingStar(layer) {
    var s = document.createElement('span');
    s.className = 'cg-shooting-star';
    s.style.top = (Math.random() * 38).toFixed(1) + '%';
    s.style.left = (10 + Math.random() * 45).toFixed(1) + '%';
    layer.appendChild(s);
    setTimeout(function () {
      if (s.parentNode) s.parentNode.removeChild(s);
    }, 1300);
  }

  /* ---------- Dokunmatik cihazlarda hover yerine "aktif kart" ----------
     Mouse yoksa (hover: none) ürün kartı ekranın ortasına gelince
     .cg-card-active alır → hover efektinin aynısı (zoom + turuncu + lift). */
  function setupMobileCardActive() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return;
    var cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          e.target.classList.toggle('cg-card-active', e.isIntersecting);
        });
      },
      { rootMargin: '-42% 0px -42% 0px', threshold: 0 }
    );
    cards.forEach(function (c) {
      io.observe(c);
    });
  }

  /* ---------- Ürün ızgaralarını stagger grubuna çevir ---------- */
  function tagProductGrids() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    main.querySelectorAll('.col-item').forEach(function (item) {
      var row = item.parentElement;
      if (row && !row.hasAttribute('data-cg-stagger')) {
        row.setAttribute('data-cg-stagger', '');
      }
    });
  }

  /* ---------- Hero içerik + buton gruplarını stagger yap ---------- */
  function tagHeroGroups() {
    document
      .querySelectorAll('.cg-hero__content, .cg-hero__buttons')
      .forEach(function (el) {
        if (!el.hasAttribute('data-cg-stagger')) {
          el.setAttribute('data-cg-stagger', '');
        }
      });
  }

  /* ---------- Görsel kenarı: gerçek yuvarlak köşeyi takip eden blur maskesi ----------
     image+text görsellerinin büyük curved köşesini (örn. 150px) siyaha eritir.
     Düz-kenar linear mask köşeyi yakalayamadığı için SVG feGaussianBlur kullanır. */
  function setupImageFeather() {
    var imgs = document.querySelectorAll('.image-content__image');
    if (!imgs.length) return;

    imgs.forEach(function (img) {
      function apply() { buildFeatherMask(img); }
      if (img.complete && img.naturalWidth) apply();
      img.addEventListener('load', apply);
    });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        imgs.forEach(buildFeatherMask);
      }, 150);
    }, { passive: true });
  }

  function buildFeatherMask(img) {
    var w = img.clientWidth, h = img.clientHeight;
    if (!w || !h) return;

    // Orijinal radius'u sakla (sonra border-radius'u sıfırlayacağız → çift kenar olmasın)
    if (!img.dataset.cgRadii) {
      var cs = getComputedStyle(img);
      img.dataset.cgRadii = [
        parseFloat(cs.borderTopLeftRadius) || 0,
        parseFloat(cs.borderTopRightRadius) || 0,
        parseFloat(cs.borderBottomRightRadius) || 0,
        parseFloat(cs.borderBottomLeftRadius) || 0
      ].join(',');
    }
    var r = img.dataset.cgRadii.split(',').map(Number);

    var f = Math.max(10, Math.min(Math.min(w, h) * 0.04, 26)); // erime mesafesi (ölçülü)
    var sd = (f / 2.6).toFixed(2); // pad ≈ 2.6σ: kenar tam söner ama köşe çakışması azalır

    // Şekli her kenardan f kadar İÇERİ çek: blur'un düz kenarlarda da
    // tuval içinde TAM sönmesi için yer açar → düz + eğri kenarlar aynı yumuşaklıkta
    var pad = f;
    var x0 = pad, y0 = pad, x1 = w - pad, y1 = h - pad;
    var maxR = Math.min(x1 - x0, y1 - y0) / 2;
    var tl = Math.min(r[0], maxR), tr = Math.min(r[1], maxR),
        br = Math.min(r[2], maxR), bl = Math.min(r[3], maxR);

    var d = 'M ' + (x0 + tl) + ',' + y0 +
            ' H ' + (x1 - tr) + ' A ' + tr + ',' + tr + ' 0 0 1 ' + x1 + ',' + (y0 + tr) +
            ' V ' + (y1 - br) + ' A ' + br + ',' + br + ' 0 0 1 ' + (x1 - br) + ',' + y1 +
            ' H ' + (x0 + bl) + ' A ' + bl + ',' + bl + ' 0 0 1 ' + x0 + ',' + (y1 - bl) +
            ' V ' + (y0 + tl) + ' A ' + tl + ',' + tl + ' 0 0 1 ' + (x0 + tl) + ',' + y0 + ' Z';

    var svg =
      "<svg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h +
      "' viewBox='0 0 " + w + " " + h + "'>" +
      "<defs><filter id='b' x='-30%' y='-30%' width='160%' height='160%'>" +
      "<feGaussianBlur stdDeviation='" + sd + "'/></filter></defs>" +
      "<path d='" + d + "' fill='white' filter='url(#b)'/></svg>";

    var url = 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
    img.style.webkitMaskImage = url;
    img.style.maskImage = url;
    img.style.webkitMaskSize = '100% 100%';
    img.style.maskSize = '100% 100%';
    img.style.webkitMaskRepeat = 'no-repeat';
    img.style.maskRepeat = 'no-repeat';
    img.style.webkitMaskComposite = 'source-over';
    img.style.maskComposite = 'add';
    img.style.borderRadius = '0px'; // şekli artık mask veriyor
  }

  /* ---------- Sticky header: scroll'da sınıf toggle ---------- */
  function setupStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    function upd() {
      header.classList.toggle('cg-header-scrolled', window.scrollY > 60);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(upd);
      }
    }, { passive: true });
    upd();
  }

  /* ---------- Sayaç: ekrana girince 0'dan hedefe say ---------- */
  function parseCountTarget(el) {
    var raw = el.getAttribute('data-cg-count') || el.textContent || '';
    var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
    var m = (el.getAttribute('data-cg-count') || el.textContent || '').match(
      /^([^0-9]*)([\d.,]+)(.*)$/
    );
    return {
      value: isNaN(num) ? 0 : num,
      prefix: m ? m[1] : '',
      suffix: m ? m[3] : ''
    };
  }
  function finalizeCounters() {
    document.querySelectorAll('[data-cg-count]').forEach(function (el) {
      var t = parseCountTarget(el);
      el.textContent = t.prefix + t.value.toLocaleString() + t.suffix;
    });
  }
  function animateCount(el) {
    var t = parseCountTarget(el);
    var start = null;
    var dur = 1600;
    var decimals = (String(t.value).split('.')[1] || '').length;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out-cubic
      var cur = t.value * eased;
      var shown = decimals ? cur.toFixed(decimals) : Math.round(cur).toLocaleString();
      el.textContent = t.prefix + shown + t.suffix;
      if (p < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }
  function setupCounters() {
    var els = document.querySelectorAll('[data-cg-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      finalizeCounters();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            animateCount(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Reveal (otomatik + deklaratif) ---------- */
  function setupReveals() {
    var targets = [];

    // Deklaratif reveal öğeleri: container seviyesinde gizlenir
    document.querySelectorAll('[data-cg-reveal]').forEach(function (el) {
      if (el.getAttribute('data-cg-reveal') === 'off') return;
      el.classList.add('cg-reveal');
      targets.push(el);
    });

    // Stagger grupları: SADECE gözlemlenir (gizleme çocuklarda olur);
    // container'a cg-reveal eklenmez → çift transform önlenir
    document.querySelectorAll('[data-cg-stagger]').forEach(function (el) {
      targets.push(el);
    });

    // Otomatik: ana içerikteki bölümler (header/footer hariç).
    // İçinde stagger grubu olan bölümü atla → giriş'i iç stagger yönetir.
    var main = document.getElementById('MainContent');
    if (main) {
      main.querySelectorAll('.shopify-section').forEach(function (sec) {
        if (sec.getAttribute('data-cg-reveal') === 'off') return;
        if (sec.classList.contains('cg-reveal')) return;
        if (sec.querySelector('[data-cg-stagger]')) return;
        sec.classList.add('cg-reveal');
        targets.push(sec);
      });
    }

    if (!('IntersectionObserver' in window)) {
      // Fallback: hepsini hemen göster
      targets.forEach(function (el) { el.classList.add('cg-reveal--in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cg-reveal--in');
            io.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    targets.forEach(function (el) { io.observe(el); });

    // İlk ekranda gerçekten görünür olanları HEMEN aç (above-the-fold hero
    // içeriği gibi). IO'nun -10% margin'i bunları açılışta dışarıda bırakabiliyor.
    window.requestAnimationFrame(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      targets.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) {
          el.classList.add('cg-reveal--in');
          io.unobserve(el);
        }
      });
    });
  }

  /* ---------- Stagger index'leri ---------- */
  function setupStaggerIndexes() {
    document.querySelectorAll('[data-cg-stagger]').forEach(function (group) {
      var children = group.children;
      for (var i = 0; i < children.length; i++) {
        children[i].style.setProperty('--cg-i', i);
      }
    });
  }

  /* ---------- Parallax (rAF throttled) ---------- */
  function setupParallax() {
    var items = Array.prototype.slice.call(
      document.querySelectorAll('[data-cg-parallax]')
    );
    if (!items.length) return;

    var ticking = false;
    var vh = window.innerHeight;

    function update() {
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) continue; // ekran dışındaysa atla
        var strength = parseFloat(el.getAttribute('data-cg-parallax')) || 0.15;
        // Bölüm merkezinin viewport merkezine uzaklığı
        var center = rect.top + rect.height / 2 - vh / 2;
        var shift = -center * strength;
        el.style.setProperty('--cg-py', shift.toFixed(1) + 'px');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      vh = window.innerHeight;
      onScroll();
    }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
